import React from "react"
import { useSelector } from "react-redux"

import { VIEW, EDIT, YES, ACTIVE } from "const"
import {
    StoreType,
    moduleIds,
} from "client/store"
import { qidProductsRoute } from "client/parts/routes"
import { Switch, Route } from "client/components"

import AccessDenied from "client/parts/accessDenied"

import List from "./list"
import View from "./view"
import Edit from "./edit"

const QidProduct = () => {
    const packageSettings = useSelector((state: StoreType) => state.system.packageSettings)
    const moduleList = useSelector((state: StoreType) => state.module.moduleList)
    const userData = useSelector((state: StoreType) => state.system.userData)

    const { qidModuleAccess } = packageSettings
    const moduleAccess = qidModuleAccess === YES && moduleList[moduleIds.qid].status === ACTIVE
    const access = userData.accountId === 1 || moduleAccess

    if (!access) return <AccessDenied />
    return (
        <Switch>
            <Route
                exact
                path={qidProductsRoute}
                component={List}
            />
            <Route
                path={`${qidProductsRoute}/${VIEW}/:productId`}
                component={View}
            />
            <Route
                path={`${qidProductsRoute}/${EDIT}/:productId`}
                component={Edit}
            />
        </Switch>
    )
}
export default QidProduct
